import auth from './auth'
import guest from './guest'
import all from './all'

export default {
	auth,
	guest,
	all
}